import { APIGet, APIPost, APIPut, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";

const apiVersion = "2024-04";
const adminType = "facility-admin";
const baseUrl = "/" + apiVersion + "/" + adminType + "/client/account";

export interface IGetAccount {
  id?: number;
  customer_id?: number;
  search?: string;
  closed?: boolean;
  limit?: number;
  offset?: number;
}

interface IPostAccountScheduledPayment {
  account_id: number;
  payment_method_id: number;
  amount: number;
  process_date: string;
  charge_balance: boolean;
  reoccur: number;
  frequency: string;
  note: string;
}

interface IPutAccountScheduledPayment {
  id: number;
  payment_method_id: number;
  amount: number;
  process_date: string;
  charge_balance: boolean;
  note: string;
}

export async function GetAccount(params?: IGetAccount, useGlobalLoader?: boolean, cancelToken?: CancelToken) {
  return await APIGet(baseUrl, params, useGlobalLoader, cancelToken);
}

//GET AccountTransactions
//Get a list of account transactions
export type TAccountTransactionsGetParams = {
  account_id: number;
};
export async function GetAccountTransactions(
  params: TAccountTransactionsGetParams,
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet(baseUrl + "/transaction", params, useGlobalLoader, token);
}

export interface IPostAccount {
  title: string;
  currency: string;
  global: boolean;
  account_number: string;
  limit: number;
  customer_id?: number;
  accounting_reference_id?: number;
  default_payment_method_id?: number;
  send_statement?: boolean;
  auto_pay_balance?: boolean;
  auto_pay_anchor_date?: number;
}

export async function PostAccount(params: IPostAccount, useGlobalLoader?: boolean) {
  return await APIPost(baseUrl, params, useGlobalLoader);
}

export interface IPutAccount {
  id: number;
  title: string;
  account_number: string;
  limit: number;
  accounting_reference_id: number | null;
  customer_id?: number | null;
  customer_ids?: number[] | null;
  tournament_id?: number | null;
  global?: boolean;
  send_statement?: boolean;
  default_payment_method_id?: number | null;
  auto_pay_balance?: boolean;
  auto_pay_anchor_date?: number | null;
}

export async function PutAccount(params: IPutAccount, useGlobalLoader?: boolean) {
  return await APIPut(baseUrl, params, useGlobalLoader);
}

export async function PostAccountTransactionRefund(params: any, useGlobalLoader?: boolean) {
  return await APIPost(baseUrl + "/transaction/refund", params, useGlobalLoader);
}

export async function PutAccountTransaction(params: { id: number, processed_at: string, payment_option_id?: number }, useGlobalLoader?: boolean) {
  return await APIPut(baseUrl + "/transaction", params, useGlobalLoader);
}

export async function PutAccountBalanceRefresh(params: { account_id: number }, useGlobalLoader?: boolean) {
  return await APIPut(baseUrl + "/update", params, useGlobalLoader);
}

export async function GetAccountScheduledPayments(
  params: { account_id: number },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet(baseUrl + "/scheduled-payment", params, useGlobalLoader, token);
}
export async function PostAccountScheduledPayment(params: IPostAccountScheduledPayment, useGlobalLoader: boolean) {
  return await APIPost(baseUrl + "/scheduled-payment", params, useGlobalLoader);
}

export async function PutAccountScheduledPayment(params: IPutAccountScheduledPayment, useGlobalLoader: boolean) {
  return await APIPut(baseUrl + "/scheduled-payment", params, useGlobalLoader);
}

export async function CancelAccountScheduledPayment(params: { id: number }, useGlobalLoader: boolean) {
  return await APIPut(baseUrl + "/scheduled-payment/cancel", params, useGlobalLoader);
}

export async function CloseHouseAccount(params: { account_id: number }, useGlobalLoader: boolean) {
  return await APIPut(baseUrl + "/close", params, useGlobalLoader);
}
export async function ReopenHouseAccount(params: { account_id: number }, useGlobalLoader: boolean) {
  return await APIPut(baseUrl + "/close", params, useGlobalLoader);
}

export interface IPostAdjustAccount {
  account_id: number;
  amount: number;
  note: string;
}

export async function PostAdjustAccount(params: IPostAdjustAccount, useGlobalLoader: boolean) {
  return await APIPost(baseUrl + "/transaction/adjustment", params, useGlobalLoader);
}

export async function PostImportAccounts(params: FormData, useGlobalLoader: boolean) {
  return APIPost(baseUrl + "/import", params, useGlobalLoader);
}

export async function AddMinimumToAccount(params: any, useGlobalLoader: boolean) {
  return APIPut(APIUrl(AdminType.FacilityAdmin, "/client/account/minimum-spending/attach"), params, useGlobalLoader);
}

export async function RemoveMinimumFromAccount(params: any, useGlobalLoader: boolean) {
  return APIPut(APIUrl(AdminType.FacilityAdmin, "/client/account/minimum-spending/detach"), params, useGlobalLoader);
}

export interface IProcessScheduledPaymentManualParams {
  scheduled_payment_id: number;
  register_id?: number;
}

export async function ProcessScheduledPaymentManual(params: IProcessScheduledPaymentManualParams, useGlobalLoader: boolean) {
  return APIPut(APIUrl(AdminType.FacilityAdmin, '/client/account/scheduled-payment/process'), params, useGlobalLoader);
}
